export default "__VITE_ASSET__01f2036a__"